import React from 'react';

import styles from './Icon.module.scss';

interface IconProps {
  src: string;
  className?: string;
  flat?: boolean;
  onClick?: (_e?: any) => void;
}

const Icon: React.FC<IconProps> = (props) => {
  const { onClick } = props;
  const classNames = [
    styles.icon,
    props.className,
    props.flat ? styles.flat__ : '',
  ].join(' ');

  return props.flat ? (
    <img
      className={classNames}
      src={props.src && props.src.toString()}
      onClick={onClick}
    />
  ) : (
    <i
      className={classNames}
      style={{
        maskImage: `url('${props.src}')`,
        WebkitMaskImage: `url('${props.src}')`,
      }}
      onClick={onClick}
    ></i>
  );
};

export default Icon;
